import React, { useState } from "react";
import "./AddUser.css";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AddUser = () => {
  const [newUser, setNewUser] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    suffix: "",
    gender: "",
    dateOfBirth: "",
    contactNumber: "",
    altContactNumber: "",
    civilStatus: "",
    address: "",
    city: "",
    province: "",
    postalCode: "",
    country: "",
    employmentType: "",
    dateHired: "",
    regularizationDate: "",
    workLocation: "",
    shiftSchedule: "",
    reportingTo: "",
    educationType: "",
    school: "",
    educationFromDate: "",
    educationToDate: "",
    educationDegree: "",
    emergencyName: "",
    emergencyRelationship: "",
    emergencyContact: "",
    emergencyAddress: "",
  });

  const navigate = useNavigate();
  const location = useLocation();
  const employeeToEdit = location.state?.employee || null;
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    if (employeeToEdit) {
      setNewUser((prev) => ({
        ...prev,
        ...employeeToEdit,
      }));
    }
  }, [employeeToEdit]);

  const handleAddUser = (e) => {
    e.preventDefault();
    console.log("User data submitted:", newUser);

    alert("✅ User added successfully!");

    setIsTransitioning(true);

    setTimeout(() => {
      navigate("/AdminMyTeam");
    }, 1500);
  };

  const handleDateHired = (e) => {
    const hired = e.target.value;
    const regDate = new Date(hired);
    regDate.setMonth(regDate.getMonth() + 6);
    setNewUser({
      ...newUser,
      dateHired: hired,
      regularizationDate: regDate.toISOString().split("T")[0],
    });
  };

  return (
    <div className="add-user-page">
      <div className="form-container">
        <h2>Add New User</h2>

        <form onSubmit={handleAddUser} className="add-user-form">
          {/* PERSONAL INFORMATION */}
          <section>
            <h3>Personal Information</h3>
            <div className="form-row">
              <input
                type="text"
                placeholder="First Name *"
                value={newUser.firstName}
                onChange={(e) =>
                  setNewUser({ ...newUser, firstName: e.target.value })
                }
                required
              />
              <input
                type="text"
                placeholder="Middle Name (Optional)"
                value={newUser.middleName}
                onChange={(e) =>
                  setNewUser({ ...newUser, middleName: e.target.value })
                }
              />
            </div>

            <div className="form-row">
              <input
                type="text"
                placeholder="Last Name *"
                value={newUser.lastName}
                onChange={(e) =>
                  setNewUser({ ...newUser, lastName: e.target.value })
                }
                required
              />
              <input
                type="text"
                placeholder="Suffix (Optional)"
                value={newUser.suffix}
                onChange={(e) =>
                  setNewUser({ ...newUser, suffix: e.target.value })
                }
              />
            </div>

            <div className="form-row">
              <select
                value={newUser.gender}
                onChange={(e) =>
                  setNewUser({ ...newUser, gender: e.target.value })
                }
                required
              >
                <option value="">Select Gender *</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </select>

              <input
                type="date"
                value={newUser.dateOfBirth}
                onChange={(e) =>
                  setNewUser({ ...newUser, dateOfBirth: e.target.value })
                }
                required
              />
            </div>

            <div className="form-row">
              <input
                type="text"
                placeholder="Contact Number *"
                value={newUser.contactNumber}
                onChange={(e) =>
                  setNewUser({ ...newUser, contactNumber: e.target.value })
                }
                required
              />
              <input
                type="text"
                placeholder="Alternate Contact Number (Optional)"
                value={newUser.altContactNumber}
                onChange={(e) =>
                  setNewUser({ ...newUser, altContactNumber: e.target.value })
                }
              />
            </div>

            <select
              value={newUser.civilStatus}
              onChange={(e) =>
                setNewUser({ ...newUser, civilStatus: e.target.value })
              }
            >
              <option value="">Select Civil Status</option>
              <option value="Single">Single</option>
              <option value="Married">Married</option>
              <option value="Widowed">Widowed</option>
              <option value="Divorced">Divorced</option>
            </select>
          </section>

          {/* ADDRESS */}
          <section>
            <h3>Address</h3>
            <input
              type="text"
              placeholder="Address *"
              value={newUser.address}
              onChange={(e) =>
                setNewUser({ ...newUser, address: e.target.value })
              }
              required
            />
            <div className="form-row">
              <input
                type="text"
                placeholder="City *"
                value={newUser.city}
                onChange={(e) =>
                  setNewUser({ ...newUser, city: e.target.value })
                }
                required
              />
              <input
                type="text"
                placeholder="Province *"
                value={newUser.province}
                onChange={(e) =>
                  setNewUser({ ...newUser, province: e.target.value })
                }
                required
              />
            </div>

            <div className="form-row">
              <input
                type="text"
                placeholder="Postal Code *"
                value={newUser.postalCode}
                onChange={(e) =>
                  setNewUser({ ...newUser, postalCode: e.target.value })
                }
                required
              />
              <input
                type="text"
                placeholder="Country *"
                value={newUser.country}
                onChange={(e) =>
                  setNewUser({ ...newUser, country: e.target.value })
                }
                required
              />
            </div>
          </section>

          {/* EMPLOYMENT INFORMATION */}
          <section>
            <h3>Employment Information</h3>
            <div className="form-row">
              <select
                value={newUser.employmentType}
                onChange={(e) =>
                  setNewUser({ ...newUser, employmentType: e.target.value })
                }
                required
              >
                <option value="">Select Employment Type *</option>
                <option value="Regular">Regular</option>
                <option value="Probationary">Probationary</option>
                <option value="Contractual">Contractual</option>
                <option value="Intern">Intern</option>
              </select>

              <input
                type="date"
                value={newUser.dateHired}
                onChange={handleDateHired}
                required
              />
            </div>

            <input
              type="date"
              value={newUser.regularizationDate}
              onChange={(e) =>
                setNewUser({ ...newUser, regularizationDate: e.target.value })
              }
              placeholder="Regularization Date"
            />

            <div className="form-row">
              <select
                value={newUser.workLocation}
                onChange={(e) =>
                  setNewUser({ ...newUser, workLocation: e.target.value })
                }
                required
              >
                <option value="">Select Work Location *</option>
                <option value="Main Office">Main Office</option>
                <option value="Remote">Remote</option>
                <option value="Field Office">Field Office</option>
              </select>

              <select
                value={newUser.shiftSchedule}
                onChange={(e) =>
                  setNewUser({ ...newUser, shiftSchedule: e.target.value })
                }
                required
              >
                <option value="">Select Shift Schedule *</option>
                <option value="Morning Shift">Morning Shift</option>
                <option value="Mid Shift">Mid Shift</option>
                <option value="Night Shift">Night Shift</option>
              </select>
            </div>

            <select
              value={newUser.reportingTo}
              onChange={(e) =>
                setNewUser({ ...newUser, reportingTo: e.target.value })
              }
              required
            >
              <option value="">Select Reporting To *</option>
              <option value="HR Department">HR Department</option>
              <option value="Sales Department">Sales Department</option>
              <option value="IT Department">IT Department</option>
              <option value="Operations Department">
                Operations Department
              </option>
            </select>
          </section>

          {/* EDUCATIONAL BACKGROUND */}
          <section>
            <h3>Educational Background</h3>
            <div className="form-row">
              <select
                value={newUser.educationType}
                onChange={(e) =>
                  setNewUser({ ...newUser, educationType: e.target.value })
                }
                required
              >
                <option value="">Select Education Type *</option>
                <option value="High School">High School</option>
                <option value="College">College</option>
                <option value="Vocational">Vocational</option>
                <option value="Post Graduate">Post Graduate</option>
              </select>
              <input
                type="text"
                placeholder="School *"
                value={newUser.school}
                onChange={(e) =>
                  setNewUser({ ...newUser, school: e.target.value })
                }
                required
              />
            </div>

            <div className="form-row">
              <input
                type="date"
                value={newUser.educationFromDate}
                onChange={(e) =>
                  setNewUser({ ...newUser, educationFromDate: e.target.value })
                }
                required
              />
              <input
                type="date"
                value={newUser.educationToDate}
                onChange={(e) =>
                  setNewUser({ ...newUser, educationToDate: e.target.value })
                }
                required
              />
            </div>

            <input
              type="text"
              placeholder="Education Degree *"
              value={newUser.educationDegree}
              onChange={(e) =>
                setNewUser({ ...newUser, educationDegree: e.target.value })
              }
              required
            />
          </section>

          {/* EMERGENCY CONTACT */}
          <section>
            <h3>Emergency Contact</h3>
            <div className="form-row">
              <input
                type="text"
                placeholder="Name *"
                value={newUser.emergencyName}
                onChange={(e) =>
                  setNewUser({ ...newUser, emergencyName: e.target.value })
                }
                required
              />
              <input
                type="text"
                placeholder="Relationship *"
                value={newUser.emergencyRelationship}
                onChange={(e) =>
                  setNewUser({
                    ...newUser,
                    emergencyRelationship: e.target.value,
                  })
                }
                required
              />
            </div>

            <input
              type="text"
              placeholder="Contact Number *"
              value={newUser.emergencyContact}
              onChange={(e) =>
                setNewUser({ ...newUser, emergencyContact: e.target.value })
              }
              required
            />
            <input
              type="text"
              placeholder="Contact Address *"
              value={newUser.emergencyAddress}
              onChange={(e) =>
                setNewUser({ ...newUser, emergencyAddress: e.target.value })
              }
              required
            />
          </section>

          <div className="form-actions">
            <button type="submit">Add User</button>
          </div>
        </form>
      </div>
      {isTransitioning && (
        <div className="transition-overlay">
          <div className="spinner"></div>
        </div>
      )}
    </div>
  );
};

export default AddUser;
